import { sportsApi } from 'api/services/sports';
import api from 'services/api/microfwk';
import { getRegion } from 'utils/Region';

const COMPETITION_ID = 'GNA5MGHG2ZVX2RD';
const SPORTS_TEAMS_PATH = `/${COMPETITION_ID}/teams`;
const SPORTS_FAVORITES_PATH = `/${COMPETITION_ID}/favorites`;
const REGION_BY_CODE = {
  mx: 'mexico',
};

const normalizeLetter = name =>
  name
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .charAt(0)
    .toUpperCase() || 'A';

const buildFlagColors = primaryHex => [
  primaryHex || '#ffffff',
  '#ffffff',
  primaryHex || '#ffffff',
];

const buildCountryFromTeam = team => ({
  id: team.teamId,
  name: team.name,
  code: team.code,
  letter: normalizeLetter(team.name),
  favorite: Boolean(team.isFavorite),
  colors: [
    team.primaryHex || '#ffffff',
    team.primaryHex || '#ffffff',
    '#ffffff',
  ],
  flagColors: buildFlagColors(team.primaryHex),
  crestUrl: team.crestUrl,
  flagUrl: team.flagUrl,
});

const getRegionName = () =>
  REGION_BY_CODE[getRegion()] || getRegion() || 'mexico';

const getTeamsParams = () => ({
  region: getRegionName(),
  timezoneOffset: new Date().getTimezoneOffset() / -60,
  authpn: process.env.AUTHPN || 'webclient',
  authpt: process.env.AUTHPT || 'tfg1h3j4k6fd7',
  device_type: 'web',
  device_category: 'web',
  device_model: 'web',
  device_manufacturer: 'generic',
});

export const fetchCompetitionFavorites = async () => {
  const { data } = await sportsApi.get(SPORTS_FAVORITES_PATH, {
    params: getTeamsParams(),
  });

  return data?.data?.favorites || [];
};

export const addCompetitionFavorite = async teamId => {
  const { data } = await sportsApi.post(
    SPORTS_FAVORITES_PATH,
    { teamId },
    {
      params: getTeamsParams(),
    },
  );

  return data;
};

export const removeCompetitionFavorite = async teamId => {
  const { data } = await sportsApi.delete(SPORTS_FAVORITES_PATH, {
    params: getTeamsParams(),
    data: { teamId },
  });

  return data;
};

export const fetchCompetitionCountries = async () => {
  const [{ data }, favorites] = await Promise.all([
    sportsApi.get(SPORTS_TEAMS_PATH, {
      params: getTeamsParams(),
    }),
    fetchCompetitionFavorites().catch(() => []),
  ]);

  const favoriteCodes = new Set(
    favorites.map(favorite => favorite.teamId || favorite.code),
  );

  return (data?.data?.teams || [])
    .map(team => ({
      ...buildCountryFromTeam(team),
      favorite:
        favoriteCodes.has(team.teamId) ||
        favoriteCodes.has(team.code) ||
        Boolean(team.isFavorite),
    }))
    .sort((countryA, countryB) =>
      (countryA.name || '').localeCompare(countryB.name || '', 'es'),
    );
};
